import Menu, { SubMenu, MenuItem, ItemGroup, Divider } from 'rc-menu';
import './index.less';

const WeaPortalRcMenu = {
  Menu,
  SubMenu,
  MenuItem,
  ItemGroup,
  Divider,
};

export default WeaPortalRcMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-portal-rc-menu/index.js